<template>
  <div class="all-wrapper">
    <headerbox :focus="3"></headerbox>
    <div class="fixed1"></div>
    <div v-html="wechatCnt" class="cnt-area"></div>
    <div class="recommend-cntr">
      <p class="header-title">热点文章</p>
      <hr />
      <div class="article-title"
           v-for="(item, index) of articleTitle"
           :key="item.id"
           @click="toOtherArticle(item.id)"
      >
        <p class="index"
           :class="{top3_index: index < 3}"
           v-if="index < 9"
        >
          {{index + 1}}
        </p>
        <p class="index"
           :class="{top3_index: index < 3}"
           v-else
           style="margin-left: -5px; margin-right: 5px"
        >
          {{index + 1}}
        </p>
        <p class="title">{{item.title}}</p>
      </div>
    </div>
    <botbox></botbox>


<!--    <p>哈哈镜</p>-->
  </div>
</template>

<script>
import headerbox from "../components/boxtop";
import botbox from "../components/botts";
import {auth} from "../request/api";
import news from "../../public/statics/newsdata"

export default {
  name: "news_view",
  data() {
    return {
      wechatCnt: ``,
      articleTitle: []
    }
  },
  components: {
    headerbox,
    botbox
  },
  mounted() {
    this.get_url_content(this.$route.query.url)

    this.get_article_list()
  },
  methods: {

    /**
     从微信公众号获取的json示例：
     {
      "id": 10,
      "time": {
        "year": "2021",
        "month": "9",
        "day": "9"
      },
      "title": "D.H.聚焦｜如何锻造自主可控开放的产业链供应链",
      "times": "September 9,2012",
      "content": "HTTP是Web浏览器与Web服务器之间通信的标准协议，是Internet上能够可靠地交换文件的重要基础。",
      "url": "https://mp.weixin.qq.com/s/-NDkZYn2j1d02twNbWEkLQ"
     },
     */

    get_url_content(wechatUrl) {
      let url = '/index/web/get_url_content'
      let data = {
        url: wechatUrl
      }
      auth(url, data).then(res => {
        if (res.data.code == 1) {
          let tmp = res.data.data
          tmp = tmp.replaceAll('data-src', 'src');
          tmp = tmp.replaceAll('origin-when-cross-origin', 'no-referrer');
          tmp = tmp.replaceAll('strict-origin-when-cross-origin', 'never');
          tmp = tmp.replace(`id="js_content" style="visibility: hidden;"`, `id="js_content" style="visibility: visible;opacity:1,color:#333333;`);
          this.wechatCnt = tmp
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    get_article_list() {
      this.articleTitle = []
      let counter = 0
      for( let item of news.newslist) {
        this.articleTitle.push({title: item.title, id: item.id})
        counter ++
        if(counter == 10) {
          break;
        }
      }
    },

    toOtherArticle(id) {
      if(id > 9) {
        let url = news.newslist[news.newslist.length - id - 1].url
        this.get_url_content(url)

      } else if(id >= 0) {
        this.$router.push({
          path: '/newviewsdetail',
          query: {
            id,
          }
        })
      }
    }
  },
}
</script>

<style scoped lang="scss">
.all-wrapper {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 0.6rem);
  height: auto;
  background: #ffffff;

  .fixed1 {
    position: fixed;
    width: 100%;
    height: 0.6rem;
    background: #000;
    top: 0;
    z-index: 1;
  }

  ::v-deep .cnt-area {
    margin: 0.6rem auto;
    p{
      color: #333333;
    }
  }

  .recommend-cntr {
    position: fixed;
    top: 50%;
    right: 30px;
    transform: translateY(-50%);
    width: 280px;
    height: 50%;

    .header-title {
      text-align: left;
      font-size: 20px;
      font-weight: bold;
      margin: 0;
    }

    .header-title::before {
      content: '|';
      margin-right: 10px;
      font-size: 20px;
      font-weight: bold;
      color: red;
    }

    .article-title {
      text-align: left;
      display: flex;
      line-height: 30px;
      font-size: 14px;
      cursor: pointer;

      .index {
        width: 25px;
        font-size: 20px;
        font-weight: bold;
      }

      .top3_index {
        color: red;
        font-size: 22px;
      }

      .title {
        width: calc(100% - 25px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .title:hover {
        color: dodgerblue;
      }
    }
  }

  ::v-deep .rich_media_content{
    color: #333333;
  }



}
</style>
<style>
.rich_media_meta {
  color: #333333!important;
}
#js_content{
  visibility: visible!important;
  opacity: 1!important;
  color: #333333!important;
}
</style>
